export const pageStyles = {
    color: "#232129",
    padding: 0,
    margin: 0,
    fontFamily: "-apple-system, Roboto, sans-serif, serif",
    maxHeight: "100vh",
    overflow: "hidden"
  };